import React from "react";
import c from "./card.module.css";
import b from "../cards/cards.module.css";
import star from "../../assets/icons_starFav.png";
import { Link } from "react-router-dom";

export default function Card({ name, image, rating, genres, id }) {
  //formato para los genres
  let formatGenre;

  if (isNaN(Number(id))) {
    formatGenre = genres?.map((e, i) => {
      if (i === genres.length - 1) {
        return e.name;
      }
      return `${e.name} / `;
    });
  } else {
    formatGenre = genres?.map((e, i) => {
      if (i === genres.length - 1) {
        return e;
      }
      return `${e} / `;
    });
  }

  return (
    <div className={`${c.card} ${b.box}`}>
      <Link to={`/home/${id}`}>
        <div className={c.gameImg}>
          <img src={image} alt="game" />
        </div>
        <div className={c.gameInfo}>
          <h4>{name}</h4>
          <span>{rating}</span>
          <img src={star} alt="Star" />
          <p>{formatGenre}</p>
        </div>
      </Link>
    </div>
  );
}
